export default __webpack_public_path__ + "static/media/team.f80d4821.jpg";